const locale = {
	dragAndDrop: "Drag & drop",
	or: "or",
	browse: "Browse files",
	filesOrFoldersHere: "files or folders here",
	cancel: "Cancel",
	clearAll: "Clear all",
	clear: "Clear",
	add: "Add",
	upload: "Upload",
	download: "Download",
	error: "error",
	byte: "B",
	kilobyte: "KB",
	megabyte: "MB",
	gigabyte: "GB",
};

export default locale;